import { FRCallback } from '@forgerock/javascript-sdk';

export const createStep = (stage: Stage, ...callbacks: FRCallback[]) => ({
  authId: 'toto',
  callbacks,
  stage,
});
